import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import { Popper } from 'react-popper';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var modifiers = {
  preventOverflow: {
    boundariesElement: 'viewport',
    padding: 10
    /**
     * Text component with tooltip support powered by Popper
     */

  }
};

var Texty =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Texty, _React$Component);

  function Texty() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isHovered: false
    });

    _defineProperty(_assertThisInitialized(_this), "renderTooltip", function (_ref) {
      var ref = _ref.ref,
          style = _ref.style,
          placement = _ref.placement,
          arrowProps = _ref.arrowProps;
      var _this$props = _this.props,
          children = _this$props.children,
          container = _this$props.container,
          tooltip = _this$props.tooltip,
          tooltipClassName = _this$props.tooltipClassName,
          tooltipStyle = _this$props.tooltipStyle,
          tooltipMaxWidth = _this$props.tooltipMaxWidth,
          hideArrow = _this$props.hideArrow;
      var content = tooltip || children;
      return ReactDom.createPortal(React.createElement("div", {
        ref: ref,
        "data-texty-tooltip": placement,
        className: tooltipClassName,
        style: _extends({}, style, {}, tooltipStyle, {
          maxWidth: tooltipMaxWidth
        }),
        onClick: _this.handleMouseEvent,
        onDoubleClick: _this.handleMouseEvent,
        onContextMenu: _this.handleMouseEvent,
        onMouseDown: _this.handleMouseEvent,
        onMouseUp: _this.handleMouseEvent
      }, content, !hideArrow && React.createElement("div", {
        ref: arrowProps.ref,
        "data-texty-arrow": placement,
        style: arrowProps.style
      })), container || _this.targetNode.ownerDocument.body);
    });

    _defineProperty(_assertThisInitialized(_this), "setTargetRef", function (ref) {
      _this.targetNode = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEvent", function (e) {
      e.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (e) {
      _this.setState({
        isHovered: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
      // eslint-disable-next-line react/prop-types
      var _this$props2 = _this.props,
          showDelay = _this$props2.showDelay,
          onMouseEnter = _this$props2.onMouseEnter;
      onMouseEnter && onMouseEnter(e);

      _this._clearHideTimer();

      if (!showDelay) {
        _this.setState({
          isHovered: true
        });

        return;
      }

      _this.showTimer = setTimeout(function () {
        _this.setState({
          isHovered: true
        });

        delete _this.showTimer;
      }, showDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function (e) {
      // eslint-disable-next-line react/prop-types
      var _this$props3 = _this.props,
          hideDelay = _this$props3.hideDelay,
          onMouseLeave = _this$props3.onMouseLeave;
      onMouseLeave && onMouseLeave(e);

      _this._clearShowTimer();

      var isHovered = _this.state.isHovered;
      if (!isHovered) return;

      if (!hideDelay) {
        _this.setState({
          isHovered: false
        });

        return;
      }

      _this.hideTimer = setTimeout(function () {
        _this.setState({
          isHovered: false
        });

        delete _this.hideTimer;
      }, hideDelay);
    });

    return _this;
  }

  var _proto = Texty.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.isHovered) {
      window.addEventListener('scroll', this.handleScroll, true);
    } else {
      window.removeEventListener('scroll', this.handleScroll, true);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, true);

    this._clearShowTimer();

    this._clearHideTimer();
  };

  _proto.render = function render() {
    /* eslint-disable no-unused-vars */
    var _this$props4 = this.props,
        Tag = _this$props4.tagName,
        children = _this$props4.children,
        placement = _this$props4.placement,
        showDelay = _this$props4.showDelay,
        hideDelay = _this$props4.hideDelay,
        tooltip = _this$props4.tooltip,
        tooltipClassName = _this$props4.tooltipClassName,
        tooltipStyle = _this$props4.tooltipStyle,
        tooltipMaxWidth = _this$props4.tooltipMaxWidth,
        hideArrow = _this$props4.hideArrow,
        container = _this$props4.container,
        rest = _objectWithoutPropertiesLoose(_this$props4, ["tagName", "children", "placement", "showDelay", "hideDelay", "tooltip", "tooltipClassName", "tooltipStyle", "tooltipMaxWidth", "hideArrow", "container"]);
    /* eslint-enable no-unused-vars */


    if (!children) return null;
    var target = this.targetNode;
    var isTruncated = !!target && target.scrollWidth > target.offsetWidth;
    var showTooltip = this.state.isHovered && isTruncated;
    return React.createElement(Tag, _extends({}, rest, {
      ref: this.setTargetRef,
      "data-texty": showTooltip,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave
    }), children, showTooltip && React.createElement(Popper, {
      referenceElement: target,
      placement: placement,
      modifiers: modifiers
    }, this.renderTooltip));
  };

  _proto._clearShowTimer = function _clearShowTimer() {
    if (this.showTimer) {
      clearTimeout(this.showTimer);
      delete this.showTimer;
    }
  };

  _proto._clearHideTimer = function _clearHideTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      delete this.hideTimer;
    }
  };

  return Texty;
}(React.Component);

Texty.defaultProps = {
  tagName: 'div',
  tooltipMaxWidth: 300,
  showDelay: 150,
  hideDelay: 150,
  hideArrow: false,
  placement: 'top'
};
Texty.propTypes = {
  /**
   * Tag name for the component
   */
  tagName: PropTypes.string,

  /**
   * Should be string or inline element
   */
  children: PropTypes.node,

  /**
   * Tooltip for the truncated text if set, or the children will be used
   */
  tooltip: PropTypes.node,

  /**
   * Classname for the tooltip
   */
  tooltipClassName: PropTypes.string,

  /**
   * Style for the tooltip
   */
  tooltipStyle: PropTypes.object,

  /**
   * Max width of the tooltip
   */
  tooltipMaxWidth: PropTypes.number,

  /**
   * Delay milliseconds to show when mouse enter
   */
  showDelay: PropTypes.number,

  /**
   * Delay milliseconds to hide when mouse leave
   */
  hideDelay: PropTypes.number,

  /**
   * Whether to show the tooltip arrow
   */
  hideArrow: PropTypes.bool,

  /**
   * The placement of the tooltip
   */
  placement: PropTypes.oneOf(['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end']),

  /**
   * The HTML Element to append the tooltip **In most cases you don't need to set it manually**
   */
  container: PropTypes.instanceOf(typeof Element !== 'undefined' ? Element : Object)
};
export default Texty;